/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 22C6 19.846 4.1752 18 2 18M9.99998 22C9.99998 17.692 6.35034 14 1.99998 14M2.5 22C2.5 22.2761 2.27614 22.5 2 22.5C1.72386 22.5 1.5 22.2761 1.5 22M2.5 22C2.5 21.7239 2.27614 21.5 2 21.5C1.72386 21.5 1.5 21.7239 1.5 22M2.5 22H1.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 10.5V10V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22V22H13.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M12.4 2H11C8.20435 2 6.80653 2 5.7039 2.45672C4.23373 3.06569 3.06569 4.23373 2.45672 5.7039C2 6.80653 2 8.20435 2 11C8.07513 11 13 15.9249 13 22C15.7956 22 17.1935 22 18.2961 21.5433C19.7663 20.9343 20.9343 19.7663 21.5433 18.2961C22 17.1935 22 15.7956 22 13V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2Z"
				fill="currentColor"
			/>
			<path
				d="M2 10.5V10V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22V22H13.5M6 22C6 19.846 4.1752 18 2 18M9.99998 22C9.99998 17.692 6.35034 14 1.99998 14M2.5 22C2.5 22.2761 2.27614 22.5 2 22.5C1.72386 22.5 1.5 22.2761 1.5 22M2.5 22C2.5 21.7239 2.27614 21.5 2 21.5C1.72386 21.5 1.5 21.7239 1.5 22M2.5 22H1.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.8785 22.2615C12.7633 22.0679 12.7345 21.762 12.677 21.1502C12.1355 15.3944 8.6056 11.8645 2.84978 11.323C2.23798 11.2655 1.93208 11.2367 1.73853 11.1215C1.55706 11.0135 1.43711 10.8817 1.34657 10.6909C1.25 10.4874 1.25 10.2083 1.25 9.65V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H14.35C13.7917 22.75 13.5126 22.75 13.3091 22.6534C13.1183 22.5629 12.9865 22.4429 12.8785 22.2615ZM1.99998 13.25C1.58577 13.25 1.24998 13.5858 1.24998 14C1.24998 14.4142 1.58577 14.75 1.99998 14.75C5.93356 14.75 9.24998 18.1037 9.24998 22C9.24998 22.4142 9.58577 22.75 9.99998 22.75C10.4142 22.75 10.75 22.4142 10.75 22C10.75 17.2804 6.76712 13.25 1.99998 13.25ZM2 17.25C1.58579 17.25 1.25 17.5858 1.25 18C1.25 18.4142 1.58579 18.75 2 18.75C3.75842 18.75 5.25 20.2576 5.25 22C5.25 22.4142 5.58579 22.75 6 22.75C6.41421 22.75 6.75 22.4142 6.75 22C6.75 19.4344 4.59198 17.25 2 17.25ZM2 20.75C1.30964 20.75 0.75 21.3096 0.75 22C0.75 22.6904 1.30964 23.25 2 23.25C2.69036 23.25 3.25 22.6904 3.25 22C3.25 21.3096 2.69036 20.75 2 20.75Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 10.5V10V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14.5C16.8297 2 17.9946 2 18.9134 2.3806C20.1386 2.88807 21.1119 3.86144 21.6194 5.08658C22 6.00544 22 7.17029 22 9.5V9.5V10M13.5 22H14H14.5C16.8297 22 17.9946 22 18.9134 21.6194C20.1386 21.1119 21.1119 20.1386 21.6194 18.9134C22 17.9946 22 16.8297 22 14.5V14.5V14M6 22C6 19.846 4.1752 18 2 18M9.99998 22C9.99998 17.692 6.35034 14 1.99998 14M2.5 22C2.5 22.2761 2.27614 22.5 2 22.5C1.72386 22.5 1.5 22.2761 1.5 22M2.5 22C2.5 21.7239 2.27614 21.5 2 21.5C1.72386 21.5 1.5 21.7239 1.5 22M2.5 22H1.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 10.5V10V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22V22H13.5M6 22C6 19.846 4.1752 18 2 18M9.99998 22C9.99998 17.692 6.35034 14 1.99998 14M2.5 22C2.5 22.2761 2.27614 22.5 2 22.5C1.72386 22.5 1.5 22.2761 1.5 22M2.5 22C2.5 21.7239 2.27614 21.5 2 21.5C1.72386 21.5 1.5 21.7239 1.5 22M2.5 22H1.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M12.677 21.1502C12.7345 21.762 12.7633 22.0679 12.8785 22.2615C12.9865 22.4429 13.1183 22.5629 13.3091 22.6534C13.5126 22.75 13.7917 22.75 14.35 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V9.65C1.25 10.2083 1.25 10.4874 1.34657 10.6909C1.43711 10.8817 1.55706 11.0135 1.73853 11.1215C1.93208 11.2367 2.23798 11.2655 2.84978 11.323C8.6056 11.8645 12.1355 15.3944 12.677 21.1502Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.24998 14C1.24998 13.5858 1.58577 13.25 1.99998 13.25C6.76712 13.25 10.75 17.2804 10.75 22C10.75 22.4142 10.4142 22.75 9.99998 22.75C9.58577 22.75 9.24998 22.4142 9.24998 22C9.24998 18.1037 5.93356 14.75 1.99998 14.75C1.58577 14.75 1.24998 14.4142 1.24998 14ZM1.25 18C1.25 17.5858 1.58579 17.25 2 17.25C4.59198 17.25 6.75 19.4344 6.75 22C6.75 22.4142 6.41421 22.75 6 22.75C5.58579 22.75 5.25 22.4142 5.25 22C5.25 20.2576 3.75842 18.75 2 18.75C1.58579 18.75 1.25 18.4142 1.25 18ZM0.75 22C0.75 21.3096 1.30964 20.75 2 20.75C2.69036 20.75 3.25 21.3096 3.25 22C3.25 22.6904 2.69036 23.25 2 23.25C1.30964 23.25 0.75 22.6904 0.75 22Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
